import { render, staticRenderFns } from "./ReviewAccountContactRequests.vue?vue&type=template&id=1a4c05d7&scoped=true"
import script from "./ReviewAccountContactRequests.vue?vue&type=script&lang=js"
export * from "./ReviewAccountContactRequests.vue?vue&type=script&lang=js"
import style0 from "./ReviewAccountContactRequests.vue?vue&type=style&index=0&id=1a4c05d7&prod&scoped=true&lang=css"
import style1 from "./ReviewAccountContactRequests.vue?vue&type=style&index=1&id=1a4c05d7&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4c05d7",
  null
  
)

export default component.exports